export const baseZh = {
  header: {
    brand: 'CikaStudio',
    tools: '工具',
    games: '游戏',
    about: '关于',
  },
  nav: {
    tools: '工具',
    games: '游戏',
    about: '关于',
  },
  actions: {
    copy: '复制',
    download: '下载',
    clear: '清空',
    copied: '已复制!',
    copyAll: '复制全部',
    downloadTxt: '下载 TXT',
    generate: '生成',
    regenerate: '重新生成',
    format: '格式化',
    minify: '压缩',
    validate: '验证',
    convert: '转换',
  },
  footer: {
    privacy: '隐私',
    terms: '条款',
    email: '联系我们',
    moreTools: '更多工具',
    copyright: '© {year} CikaStudio. 保留所有权利。',
  },
  language: {
    en: 'English',
    zh: '中文',
  },
  theme: {
    light: '浅色',
    dark: '深色',
  },
  common: {
    clientSide: '100% 客户端处理',
    noUpload: '不上传数据',
    noAccount: '无需账号',
    loading: '加载中...',
    error: '错误',
    success: '成功',
  },
};
